<template>
            <div>
                <div>
                    <div class="form-group">
                        <div class="input-group m-b">
                            <input type="text" v-model="existingCustomerNumber" class="form-control" placeholder="Search For Existing Customer By Number" />
                            <span class="input-group-btn"><button v-on:click="checkForExistingCustomer()" type="button" class="btn btn-primary"><i class="fa fa-search"></i></button></span>
                        </div>
                    </div>

                        <div class="form group row" style="padding-bottom:10px;">
                                <div class="col-md-6 delivery-custom-btn" style="padding-right:5px;">
                                    <button type="button" class="btn btn-w-m orderType" id="3" @click="checkDeliveryTakeAway(3)">Delivery</button>
                                </div>
                                <div class="col-md-6 delivery-custom-btn" style="padding-left:5px;">
                                    <button type="button" class="btn btn-w-m  orderType" id="1" @click="checkDeliveryTakeAway(1)">Take Away</button>
                                </div>
                        </div>

                    <hr/>
                    <form method="post" @submit.prevent="submitNewDeliveryOrderCustomer()">
                        <h3>Customer Details</h3>
                        <div class="form-group">
                            <label>Full Name</label>
                            <input required="required" v-model="customer.name" type="text" class="form-control"  placeholder="Full Name...">
                        </div>
                        <div class="form-group">
                            <label>Contact 1</label>
                            <input v-model="customer.contact1" readonly="readonly" type="text" class="form-control"  placeholder="Contact 1...">
                        </div>
                        <div class="form-group">
                            <label>Contact 2</label>
                            <input v-model="customer.contact2" type="text" v-on:blur="checkForCustomer(2)" class="form-control"  placeholder="Contact 2...">
                        </div>
                        <div class="form-group">
                            <label>Contact 3</label>
                            <input v-model="customer.contact3" type="text" v-on:blur="checkForCustomer(3)" class="form-control"  placeholder="Contact 3...">
                        </div>
                        <div class="form-group">
                            <label>Email</label>
                            <input :required="($parent.newOrderType===3 || $parent.newOrderType===4)? true: false" v-model="customer.email" type="text" class="form-control"  placeholder="Email...">
                        </div>
                         <div v-if="parseInt(orderTypeId)===3">
                            <h3>Address</h3>
                            <CitiesAndAreas :isAddingNewCustomer="true" ref="cityAndAreaComp" />
                            <div class="form-group">
                                <label>Address</label>
                                <textarea required="required" v-model="customer.customerAddressesById[0].address" placeholder="Address..." class="form-control" rows="5"></textarea>
                            </div>
                        </div>
                        <div class="form-group" v-if="parseInt(orderTypeId) === 1">
                            <label>Select Branch</label>
                            <select class="form-control" v-model="branchId" style="background: #FFFFFF" required>
                                <option v-for="branch in allBranches" v-bind:key="branch.id+'_branch'" v-bind:value="branch.id">{{branch.areasByAreaId.name}}</option>
                            </select>
                        </div>
                        <div class="row" v-if="orderTypeId!==''">
                            <div class="col-md-12">
                                <button  type="submit" v-bind:disabled="disableBtn" class="btn btn-primary pull-right">Submit</button>
                            </div>
                        </div>
                        <br>
                    </form>
                </div>
            </div>
</template>

<script>
    /* eslint-disable */
    import CitiesAndAreas from "../utils/CitiesAndAreas";
    export default {
        name: "NewDeliveryOrderCustomer",
        props: ['orderSource'],
        components: {CitiesAndAreas},
        data() {
            return {
                orderTypeId:"",
                branchId:"",
                selectedCityId:"",
                disableBtn: false,
                restaurant: "",
                existingCustomerNumber: "",
                allBranches:"",
                customer: {
                    "id": 0,
                    "name": "",
                    "contact1": null,
                    "contact2": null,
                    "contact3": null,
                    "email": "",
                    "blockReasons" : "",
                    "customerStatus": "active",
                    customerAddressesById: [{
                        address:"",
                        areasByAreaId:{},
                        "customersByCustomerId": {
                            "id": 0,
                        },
                        deleted: false
                    }]
                },
                emailReg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
            }
        },
        methods: {
            load: function (restaurant, callerNumber) {
                this.restaurant = restaurant;
                this.customer.contact1 = callerNumber;
                let params = new URLSearchParams();
                params.append("restaurant_id", this.restaurant.id);
                this.$http.post(this.$store.state.mainAppURL + "restaurants/get_all_branches", params).then(resp => {
                    this.allBranches= resp.data;
                });
                
            },
            isEmailValid: function() {
                return (this.customer.email == "")? true : (this.emailReg.test(this.customer.email)) ? true : false;
            },
            checkDeliveryTakeAway: function(orderType){
                this.orderTypeId=orderType;
                $(".orderType").removeClass("yellow-bg");
                $('#'+this.orderTypeId).addClass("yellow-bg");
            },
            checkForExistingCustomer: async function () {
                let params = new URLSearchParams();
                params.append("contact_number", this.existingCustomerNumber);
                let existingCustomer = await this.$http.post(this.$store.state.mainAppURL + "customers/find_customer_from_contact", params);
                console.log(existingCustomer.data);
                if(existingCustomer.data !== "" && existingCustomer.data !== null){
                    this.$parent.existingCustomer=true;
                    let params2 = new URLSearchParams();
                    params2.append("caller_number", this.customer.contact1);
                    let isDiscardCustomer = await this.$http.post(this.$store.state.mainAppURL + "orders/discard_order_placement", params2);
                    if(isDiscardCustomer.data){
                        $("#newDeliveryOrderCustomerModal").modal("hide");
                        this.resetData();
                        this.$parent.callerNumber = existingCustomer.data.contact1;
                        this.$parent.makeNewOrderRequest();
                    }
                }else{
                    swal("Info!","Customer with number: " + this.existingCustomerNumber + " is not exist.", "info");
                }
            },
            submitNewDeliveryOrderCustomer: function () {
                if(!this.isEmailValid()){
                    swal("ERROR!", "Enter Valid Email", "error");
                    return;
                }
                this.$parent.popUpSpinner="";
                if(parseInt(this.orderTypeId)===1){
                    this.customer.customerAddressesById[0].areasByAreaId.id=this.$store.state.takeAwayAddressId;
                    this.customer.customerAddressesById[0].address="Dummy";
                    this.selectBranch();
                    return;
                }
                this.customer.customerAddressesById[0].areasByAreaId.id = this.$refs.cityAndAreaComp.selectedArea;
                this.selectedCityId= this.$refs.cityAndAreaComp.city.id;                    
                this.disableBtn = true;
                this.$parent.isHideSpinner = "";
                this.$http.post(this.$store.state.mainAppURL + "orders/set_customer_in_delivery_order", this.customer).then(resp => {

                  if(resp.data === null){
                    swal("Error!", "Error while setting order customer!", "error");
                  } else {
                    if( resp.data === "") {
                      swal("Error!", "No Order Placement Exist!", "error");
                      this.$parent.orderDoesNotExists();
                    }else{
                      this.$parent.initializeOrderFirst(resp.data);
                    }
                    this.resetData();
                    this.disableBtn = false;
                    this.$parent.popUpSpinner="hide";
                    $("#newDeliveryOrderCustomerModal").modal("hide");
                  }
                });
            },
            checkForCustomer: function (contactNumber){
                let params = new URLSearchParams();
                let customerContact = (contactNumber === 2) ? this.customer.contact2 : this.customer.contact3;
                params.append("contact_number", customerContact);
                this.$http.post(this.$store.state.mainAppURL + "customers/find_customer_from_contact", params).then(resp => {
                    if(resp.data !== null && resp.data !== ""){
                        let existingCustomer = resp.data;
                        if(contactNumber === 2){
                            if(existingCustomer.contact2 === null || existingCustomer.contact2 === ""){
                                existingCustomer.contact2 = this.customer.contact1;
                            }else{
                                existingCustomer.contact3 = this.customer.contact1;
                            }
                        }else{
                            //check for contact 1
                            if(existingCustomer.contact2 === null || existingCustomer.contact2 === ""){
                                existingCustomer.contact2 = this.customer.contact1;
                            }else{
                                existingCustomer.contact3 = this.customer.contact1;
                            }
                            //check for contact 2
                            if(existingCustomer.contact3 === null || existingCustomer.contact3 === "" ){
                                existingCustomer.contact3 = this.customer.contact2;
                            }
                        }

                        console.log(existingCustomer);
                        swal({
                            title: "ALREADY EXIST!",
                            html : "Customer (Mr/Mrs. <b>"+existingCustomer.name+"</b>) With Contact #: <b>"+customerContact+"</b> is already exist! Please press OK to fetch the menu.",
                            type: "info",
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            confirmButtonText: "FETCH MENU!",
                            showLoaderOnConfirm: true,
                            preConfirm: () => {
                                this.$http.post(this.$store.state.mainAppURL + "customers/update_customer", existingCustomer).then(resp => {
                                    if(resp.data){
                                        let params2 = new URLSearchParams();
                                        params2.append("caller_number", this.customer.contact1);
                                        this.$http.post(this.$store.state.mainAppURL + "orders/discard_order_placement", params2).then(resp => {
                                            if(resp.data){
                                                $("#newDeliveryOrderCustomerModal").modal("hide");
                                                this.resetData();
                                                this.$parent.callerNumber = existingCustomer.contact1;
                                                this.$parent.makeNewOrderRequest();
                                            }else{
                                                swal("ERROR!", "Some thing wrong while updating customer! contact Mr Musab Bukarhi Immediately", "error");
                                            }
                                        });
                                    }else{
                                        swal("ERROR!", "Some thing wrong while updating customer! contact Mr Musab Bukarhi Immediately", "error");
                                    }
                                });
                            },
                        }).then( (result) => {
                            console.log(result);
                        });
                    }
                }).catch(ex => {
                    swal("Error!", ex + " There is some error! Please Contact DVM Tech Support Immediately and take a screen-shot.", "error");
                });
            },
            resetData: function () {
                this.orderTypeId="";
                $(".orderType").removeClass("yellow-bg");
                Object.assign(this.$data, this.$options.data.call(this));
                if(this.$refs.cityAndAreaComp!==undefined){
                    this.$refs.cityAndAreaComp.resetData();
                }
                
            },
            selectBranch: function(){
                let params = new URLSearchParams();
                params.append("branch_id", this.branchId);
                params.append("is_find_optimize", false);
                params.append("order_type", this.orderTypeId);
                params.append("order_source", this.orderSource);
                params.append("caller_number", this.customer.contact1);
                this.isHideSpinner = "";
                this.$http.post(this.$store.state.mainAppURL + "orders/update_branch_in_delivery_order", params).then(resp => {
                    console.log(resp.data)
                    this.$http.post(this.$store.state.mainAppURL + "orders/set_customer_in_delivery_order", this.customer).then(resp => {
                      if(resp.data === ''){
                        swal("Error!", "No Order Placement Exists.", "error");
                        this.$parent.orderDoesNotExists();
                      }else{
                        this.$parent.load(resp.data);
                      }
                      this.disableBtn = false;
                      this.$parent.popUpSpinner="hide";
                      $("#newDeliveryOrderCustomerModal").modal("hide");
                      this.resetData();
                    })
                }).catch(ex => {
                    this.isHideSpinner = "hide";
                    swal("Error!", ex + " Please try again or Contact DVM Tech Support", "error");
                });
            }
        }
    }
</script>

<style scoped>
.resize{
    width:70px;
    height:70px;
}
.orderType{
    width: 100%;
    outline: none;
}

.delivery-custom-btn button:hover{
    border: 1px solid #dfdfdf;
    background-color: #f8ac59;
}

</style>
